import A1 from '../spritesheets/keyboard/A1.png';
import A2 from '../spritesheets/keyboard/A2.png';
import B1 from '../spritesheets/keyboard/B1.png';
import B2 from '../spritesheets/keyboard/B2.png';
import C1 from '../spritesheets/keyboard/C1.png';
import C2 from '../spritesheets/keyboard/C2.png';
import D1 from '../spritesheets/keyboard/D1.png';
import D2 from '../spritesheets/keyboard/D2.png';

import one1 from '../spritesheets/keyboard/one1.png';
import one2 from '../spritesheets/keyboard/one2.png';
import two1 from '../spritesheets/keyboard/two1.png';
import two2 from '../spritesheets/keyboard/two2.png';
import three1 from '../spritesheets/keyboard/three1.png';
import three2 from '../spritesheets/keyboard/three2.png';
import four1 from '../spritesheets/keyboard/four1.png';
import four2 from '../spritesheets/keyboard/four2.png';

import { useContext } from 'react';
import { EnteredContext } from '../context/EnteredContext';

export default function Keyboard() {
  const { entered, addEntered } = useContext(EnteredContext);

  return (
    <div className="flex flex-col gap-1">
      <div className="flex gap-1">
        <img
          src={entered.indexOf('A') !== -1 ? A2 : A1}
          onClick={() => {
            addEntered('A');
          }}></img>
        <img
          src={entered.indexOf('B') !== -1 ? B2 : B1}
          onClick={() => {
            addEntered('B');
          }}></img>
        <img
          src={entered.indexOf('C') !== -1 ? C2 : C1}
          onClick={() => {
            addEntered('C');
          }}></img>
        <img
          src={entered.indexOf('D') !== -1 ? D2 : D1}
          onClick={() => {
            addEntered('D');
          }}></img>
      </div>
      <div className="flex gap-1">
        <img
          src={entered.indexOf('1') !== -1 ? one2 : one1}
          onClick={() => {
            addEntered('1');
          }}></img>
        <img
          src={entered.indexOf('2') !== -1 ? two2 : two1}
          onClick={() => {
            addEntered('2');
          }}></img>
        <img
          src={entered.indexOf('3') !== -1 ? three2 : three1}
          onClick={() => {
            addEntered('3');
          }}></img>
        <img
          src={entered.indexOf('4') !== -1 ? four2 : four1}
          onClick={() => {
            addEntered('4');
          }}></img>
      </div>
    </div>
  );
}
